import React from 'react';
import cn from 'classnames';
import styles from './QuestionDescription.module.scss';

const QuestionDescription = ({ description, fullDescription = false }) => {
  const text =
    description.length > 85 && !fullDescription
      ? `${description.slice(0, 85)}...`
      : description;

  return (
    <p className={cn(styles.root, { [styles.full]: fullDescription })}>
      {text}
    </p>
  );
};

export default QuestionDescription;
